<template>
    <v-row class="text-body-2 deep-grey--text text--lighten-1" no-gutters>
        <v-col class="px-2 text-right">
            <div
                v-show="name && name.length"
                role="form"
                aria-label="field-lablel-xbo-name"
            >
                {{ nameLabel }}:
            </div>
            <div
                v-show="id && id.length"
                role="form"
                aria-label="field-label-xbo-id"
            >
                {{ idLabel }}:
            </div>
            <div
                v-show="status && status.length"
                role="form"
                aria-label="field-label-status"
            >
                {{ statusLabel }}:
            </div>
        </v-col>
        <v-col cols="auto" class="font-weight-medium">
            <div
                v-show="name && name.length"
                role="form"
                aria-label="field-value-xbo-name"
            >
                {{ name }}
            </div>
            <div
                v-show="id && id.length"
                role="form"
                aria-label="field-value-xbo-id"
            >
                {{ id }}
            </div>
            <div
                v-show="status && status.length"
                role="form"
                aria-label="field-value-status"
            >
                {{ status }}
            </div>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: 'ServiceAccountInfo',
    props: {
        name: {
            type: String,
            required: false,
            default: ''
        },
        nameLabel: {
            type: String,
            default: 'XBO Name'
        },
        id: {
            type: String,
            required: false,
            default: ''
        },
        idLabel: {
            type: String,
            default: 'XBO Id'
        },
        status: {
            type: String,
            required: false,
            default: ''
        },
        statusLabel: {
            type: String,
            default: 'Status'
        }
    }
};
</script>
